export const TRUE_QUERY_VALUES = new Set(['true', '1']);
